export const ACCESS_TOKEN = 'authorization';
// 加密字段
export const encryptionField = ['报警电话', '报警地址', '报警内容', '反馈内容'];
